<div class="mt-9">
  <div class="row justify-content-between align-items-end g-3 mb-5">
    <div class="col-12 col-sm-auto col-xl-8">
      <h2 class="mb-0 d-flex flex-wrap align-items-center">
        <span>Акции у пользователя</span>
      </h2>
    </div>
  </div>
  <div class="row g-5" [formGroup]="newPromotionForm">
    <div class="col-md-3">
      <div class="form-floating">
        <input type="text" name="name" formControlName="name" class="form-control" placeholder="Название">
        <label>Название</label>
      </div>
    </div>

    <div class="col-md-2">
      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" name="isEnabled" formControlName="isEnabled">
        <label class="form-check-label">Активно</label>
      </div>
    </div>

    <div class="col-md-3">
      <div class="form-floating">
        <input type="text" name="promoCode" formControlName="promoCode" class="form-control"
          placeholder="Промокод">
          <label>Промокод</label>
        </div>
      </div>

      <div class="col-md-2 d-flex align-items-center">
        <button class="btn btn-phoenix-primary" [disabled]="newPromotionForm.invalid || isBusy"
        (click)="addNew()">Добавить</button>
      </div>
      <div class="col-12">
        <div class="file-container">
          <div class="file-square" [ngStyle]="getNewPromoImageStyle()">
            <input type="file" id="docs" accept="image/*" (change)="selectFile(newPromotionForm, $event)" />
            <label for="docs">
              <i class="fa-solid fa-plus"></i>
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 mb-5">
        <div class="border-bottom"></div>
      </div>
    </div>

    <div class="row g-5">
      @for (item of items; track item; let i = $index) {
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="row g-2" [formGroup]="item">
                <div class="col-12">
                  <div class="form-floating">
                    <input type="text" name="name{{i}}" formControlName="name" class="form-control"
                      placeholder="Наименование">
                      <label>Наименование</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" name="isEnabled{{i}}"
                        formControlName="isEnabled">
                        <label class="form-check-label">Активно</label>
                      </div>
                    </div>
                    <div class="col-12 mb-2">
                      <div class="text-center mb-2">
                        <img [src]="'/'+item.get('image')?.value">
                      </div>
                      <input type="file" id="docs" accept="image/*" class="form-control"
                        (change)="selectFile(item, $event)" />
                      </div>
                      <div class="col-12">
                        <div class="form-floating">
                          <input type="text" name="promoCode" formControlName="promoCode" class="form-control"
                            placeholder="Промокод">
                            <label>Промокод</label>
                          </div>
                        </div>
                        <div class="col-12">
                          <button class="btn btn-phoenix-primary w-100"
                          (click)="savePromotion(item)">Сохранить</button>
                        </div>
                        <div class="col-12">
                          <button class="btn btn-phoenix-danger w-100"
                          (click)="removePromotion(item)">Удалить</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>